/**
 * CompactCreatorRow · P5 (Bereichstrennung §4.1 / §4.2)
 *
 * Kompakte Zeile für die rechte Social-Sidebar:
 *  - kleines rundes Social-Avatarbild
 *  - Social-Username/Anzeigename
 *  - optionaler kompakter Folgen-Button
 * KEINE großen Creator-Cards / keine Coverbilder. Nur Social-Identitäten.
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";

export default function CompactCreatorRow({ creator, showFollow = false, testIdPrefix = "compact-creator" }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handle = creator.handle || creator.person_id || creator.profile_id;
  const name = creator.display_name || creator.handle || "Creator";
  const initials = (name || "?").slice(0, 2).toUpperCase();
  const [following, setFollowing] = useState(false);
  const [busy, setBusy] = useState(false);

  const follow = async (e) => {
    e.stopPropagation();
    if (busy || following) return;
    setBusy(true);
    try {
      await api.post(`/profiles/${creator.person_id || creator.profile_id}/follow`);
      setFollowing(true);
    } catch { /* ignore */ }
    finally { setBusy(false); }
  };

  return (
    <button
      type="button"
      data-testid={`${testIdPrefix}-${handle}`}
      onClick={() => handle && navigate(`/user/${handle}`)}
      className="w-full flex items-center gap-3 px-2 py-2 rounded-lg hover:bg-[#FAFAFA] text-left"
    >
      <span className="w-9 h-9 rounded-full overflow-hidden bg-[#F5F5F5] shrink-0 flex items-center justify-center">
        {creator.avatar_url ? (
          <img src={creator.avatar_url} alt="" className="w-full h-full object-cover" />
        ) : (
          <span className="text-xs font-bold text-[#999]">{initials}</span>
        )}
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-sm font-medium text-[#0A0A0A] truncate">{name}</span>
      </span>
      {showFollow && (
        <span
          data-testid={`${testIdPrefix}-follow-${handle}`}
          onClick={follow}
          className={`shrink-0 text-xs font-semibold px-3 py-1 rounded-full transition-colors ${
            following ? "text-[#999]" : "text-[#0A0A0A] hover:bg-[#F5F5F5]"
          }`}
        >
          {following ? t("suggest.following_label", { defaultValue: "Folgst du" }) : t("suggest.follow", { defaultValue: "Folgen" })}
        </span>
      )}
    </button>
  );
}
